import { IonCard, IonCardContent, IonContent, IonHeader, IonItem, IonLabel, IonNote, IonThumbnail } from '@ionic/react';
import { useGetQuotesQuery, useGetUserInfoQuery } from '../../services/api/ebioro/ebioro';
import { useAccountDetailsQuery } from '../../services/api/stellar';
import { useAppDispatch, useAppSelector } from '../../services/redux/hook';
import { setSelectedAsset } from '../../services/redux/slices/selected-asset/selected-asset';
import { formatConversion } from '../../services/utils/formatConversion';
import { Asset, PaymentDestinationInfo } from '../../types/types';
import AppHeader from '../AppHeader/AppHeader'
import { App, BackButtonListenerEvent } from '@capacitor/app';
import { useTranslation } from 'react-i18next';
import { PropsWithChildren } from 'react';
import { setPaymentDestinationInfo } from '../../services/redux/slices/paymentDestinationInfo/paymentDestinationInfo';
import useCryptoMode from '../../hooks/useCryptoMode';

interface AssetModalProps extends PropsWithChildren {
    closeModal: Function;
    title?: string;
}

const ebioroAuthDomain = import.meta.env.VITE_API_AUTH_DOMAIN || '';

const AssetModal: React.FC<AssetModalProps> = (props) => {

    const { t, i18n } = useTranslation();
    const {cryptoMode} = useCryptoMode();

    // dealing with android back button and modals
    App.addListener('backButton', (ev: BackButtonListenerEvent) => {
        props.closeModal()
    });

    let balances: any;
    const ebioroAuthToken = useAppSelector((state) => state.sep10AuthToken.tokens[ebioroAuthDomain]);
    const walletInfo = useAppSelector((state) => state.walletInfo);
    const { data: accountDetails } = useAccountDetailsQuery(walletInfo.account_key);
    const { data: userInfo } = useGetUserInfoQuery(ebioroAuthToken);
    const dispatch = useAppDispatch();
    const supportedAssets = useAppSelector((state) => state.supportedAssets.supportedAssets);
    const paymentInfo: PaymentDestinationInfo = useAppSelector((state) => state.paymentDestinationInfo);

    let coins = '';

    supportedAssets.map((asset: any) => {

        if (!coins || coins === '') {
            coins = asset.code


        }
        else {
            coins = coins + ',' + asset.code;
        }

    })

    const { data: quotes } = useGetQuotesQuery({ coins: coins, authToken: ebioroAuthToken });

    const getAssetTotalValue = (asset: Asset) => {

        if (quotes && userInfo) {

            for (const [key, value] of Object.entries(quotes)) {

                if (key === asset.code) {

                    const values: any = value;
                    const quoteValue = values[userInfo.currency_code];
                    const quote = (quoteValue * balances[asset.identifier].available.toNumber());
                    return quote
                }
            }

        }

        else {
            return 0
        }

    }

    if (accountDetails && accountDetails.details.id) {

        balances = accountDetails.details.balances;
    }

    const selectAsset = (asset: Asset) => {

        let updatedPaymentInfo = { ...paymentInfo }
        updatedPaymentInfo.destination_asset = asset;
        dispatch(setSelectedAsset(asset));
        dispatch(setPaymentDestinationInfo(updatedPaymentInfo));
        props.closeModal();

    }

    return (
        <>
            <IonHeader className="ion-no-border">
                {
                    props.title ?
                        <AppHeader
                            title={props.title}

                        >
                        </AppHeader>
                        : <></>
                }
            </IonHeader>


            <IonContent fullscreen>

                <IonCard>
                    <IonCardContent>

                            {
                                supportedAssets
                                .filter((asset:Asset) => {
                    
                                    return asset.type === 'fiat' || (cryptoMode && asset.type === 'crypto');
                                  })
                                .map((asset: Asset) => {

                                     // Only include assets that have a balance in the account
                                    if (accountDetails?.details.balances[asset.identifier]) {
                                        return (
                                            <IonItem key={asset.identifier} lines="none" onClick={() => { selectAsset(asset) }}>
    
                                                <IonThumbnail className="accountsPage_Thumbnail_Flag" slot="start">
                                                    <img src={asset.icon} />
                                                </IonThumbnail>
    
                                                <IonLabel className="accountsPage_AssetLabel">
                                                    <h4>
                                                        {asset.display_code}
                                                    </h4>
    
                                                </IonLabel>
    
    
                                                <IonLabel className="accountsPage_amount">
    
                                                    <h4>
                                                        {formatConversion(balances[asset.identifier] ? getAssetTotalValue(asset) as number : 0) + " " + userInfo?.currency_code}
    
                                                    </h4>
                                                    <IonNote className='accountsPage_IonNote'>
                                                        {(balances[asset.identifier] ? formatConversion(balances[asset.identifier].available.toNumber()) : 0) + " " + asset.display_code}
                                                    </IonNote>
                                                </IonLabel>
    
                                            </IonItem>
    
                                        )
                                        
                                    }

                                    
                                })
                            }

                       

                    </IonCardContent>
                </IonCard>



            </IonContent>
        </>
    )
}

export default AssetModal;